import { makeStyles } from '@material-ui/core/styles';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.common.coral,
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

type LinkProps =
  | {
      children: ReactNode;

      href: string;

      to?: never;
    }
  | {
      children: ReactNode;

      href?: never;

      to: string;
    };

function Link({ children, href, to }: LinkProps) {
  const classes = useStyles();

  if (href) {
    return (
      <a className={classes.link} href={href}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <RouterLink className={classes.link} to={to}>
        {children}
      </RouterLink>
    );
  }

  return null;
}

export default Link;
